import axios from "axios";
import { DEV_API } from "../Common/Constant";

const MyAxios = axios.create({
  baseURL: DEV_API,
  withCredentials: true,
});

MyAxios.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export default MyAxios;
